export const setUserSignUp = (firstname,lastname,email) => {
    return{
        username:email,
        firstname,
        lastname,
        email
    }
}
